<template>
    <div>
        <hts-card class="mt-2">
            <div class="">
                <hts-form-button
                    icon-name="hi-check-icon"
                    icon-position="right"
                    color="primary"
                    type="submit"
                    :loading="false"
                    @click="handleCreatePaymentNote">
                    {{ $t('labels.addNew') }}
                </hts-form-button>
            </div>
            <hts-ui-tabs
                v-model="tabSelected"
                :tabs="tabs" />
            <list-payment-note
                ref="listPaymentNote"
                :type="tabSelected"
                :trip="trip"
                :charge="charge"
                @view="handleView"
                @edit="openEdit" />
        </hts-card>

        <create-payment-note
            ref="createPaymentNote"
            @created="handleChange" />

        <edit-payment-note
            ref="editPaymentNote"
            @changed="handleChange" />

        <detail-payment-note ref="detailPaymentNote" />

        <delete-payment-note
            ref="deletePaymentNote"
            @refreshTables="handleChange" />
    </div>
</template>
<script setup lang="ts">
import CreatePaymentNote from './create.vue'
import DeletePaymentNote from './delete.vue'
import DetailPaymentNote from './detail.vue'
import EditPaymentNote from './edit.vue'
import ListPaymentNote from './list-payment-note.vue'

const { $formatters } = useNuxtApp()
const props = defineProps({
  trip: Object,
  charge: Object
})

const { trip, charge } = toRefs(props)
const tabs = ref([
  {
    key: 'revenue',
    label: $t('labels.revenue'),
    active: true
  },
  {
    key: 'cost',
    label: $t('labels.cost')
  },
  {
    key: 'pobo',
    label: $t('labels.pobo')
  },
  {
    key: 'cobo',
    label: $t('labels.pobo')
  }
])
const tabSelected = ref('revenue')
const createPaymentNote = ref()
const detailPaymentNote = ref()
const deletePaymentNote = ref()
const editPaymentNote = ref()
const listPaymentNote = ref()

const emits = defineEmits(['change', 'refreshTableInvoice'])

const handleCreatePaymentNote = () => {
  createPaymentNote.value && createPaymentNote.value.open(tabSelected.value, trip?.value, charge?.value)
}

const openEdit = (data: any) => {
  editPaymentNote.value && editPaymentNote.value.open(trip?.value?._id, data?._id)
}

const handleView = (data: any) => {
  detailPaymentNote.value && detailPaymentNote.value.open(trip?.value?._id, data?._id)
}
const handleChange = () => {
  emits('change')
  listPaymentNote.value?.refreshTables()
}

const openDelete = (debit: any) => {
  if (!debit) {
    return null
  }

  deletePaymentNote.value?.open(trip?.value?._id, debit._id)
}
</script>
